
import UserResults from '../component/users/UserResults'
import UserSearch from '../component/users/UserSearch'

function Home() {

    return (
        <>
            <UserSearch />
            <UserResults />
        </>
    )
}

export default Home